import React, {useState, useEffect, useRef} from 'react'
import {withRouter, useParams, useHistory, useLocation} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap'
import {Card, Empty, Spin, Modal, Tag, Form, Input, Button} from 'antd';
import UserInfo from "../../auth/UserInfo";
import Api from "../../../services/Api";
import HelperGeneral from "../../../helpers/HelperGeneral";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar, faXmark} from "@fortawesome/free-solid-svg-icons";
import {setGlobalSpinner} from "../../../services/redux/actions/GeneralAction";
import TextArea from "antd/es/input/TextArea";
import ReactHtmlParser from "react-html-parser";

const {Meta} = Card;

const Archive = () => {
    const {documentType} = useParams();
    const history = useHistory();
    const location = useLocation();
    const playerRef = React.useRef();
    const formRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [loadingDocumentTypes, setLoadingDocumentTypes] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [activeDocumentType, setActiveDocumentType] = useState(documentType === 'sss' ? 32 : 33);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalMediaUrl, setModalMediaUrl] = useState("");
    const [modalImageVisible, setModalImageVisible] = useState(false);
    const [modalImageUrls, setModalImageUrls] = useState([]);
    const [faqData, setFaqData] = useState([]);
    const [activeSubCategory, setActiveSubCategory] = useState(0);
    const [overlayColors, setOverlayColors] = useState(
        {
            "AD CARE": "#a4c8e1",
            "DAILY": "#e2d0d8",
            "HYDRA": "#a5d7ef",
            "REPAIR": "#B7BADB",
            "SD CARE": "#A4C8E1",
            "SEBUM": "#59D1BB",
            "SENSETIVE": "#F3D8CB",
            "UV DEFENCE": "#FFCD00",
        }
    );

    useEffect(() => {
        getCategoryList();
    }, [])

    useEffect(() => {
        setDocuments([]);
        setActiveSubCategory(0);

        if (activeDocumentType !== 32 && location?.pathname === "/dokumanlar/sss") {
            history?.replace("/dokumanlar");
        } else if (activeDocumentType === 32 && location?.pathname === "/dokumanlar") {
            history?.replace("/dokumanlar/sss");
        }

        if (activeDocumentType === 32) {
            getFaq();
        } else if (activeDocumentType !== 31) {
            getDocuments();
        }
    }, [activeDocumentType])

    const getDocuments = (subCategory) => {
        setLoading(true);
        if (activeDocumentType !== 0) {
            let args = ['other_2'];
            if (subCategory) {
                args.push(subCategory);
            }
            Api.getDocuments(...args).then((e) => {
                setLoading(false);
                setDocuments(e?.data?.data ?? []);
            }).catch((e) => {
                HelperGeneral.alert(e);
                setLoading(false);
            })
        }
    }

    const getCategoryList = () => {
        setLoadingDocumentTypes(true);
        Api.getCategoryList('other_2').then((e) => {
            if (!documentType) {
                setActiveDocumentType(e?.data[0]?.id);
            }
            setDocumentTypes(e?.data);
            setLoadingDocumentTypes(false);
        }).catch((e) => {
            setLoadingDocumentTypes(false);
            HelperGeneral.alert(e);
        })
    }

    const getFaq = () => {
        setLoading(true);
        Api.getOtherPages().then((e) => {
            setLoading(false);
            setFaqData(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    const onFinishMessageForm = (values) => {
        setGlobalSpinner(true);
        const data = {
            form_id: 6,
            form_data: {
                contact_name: values?.firstName,
                contact_lastname: values?.lastName,
                contact_email: values?.email,
                contact_message: values?.message,
            }
        };

        Api.createCommunication(data).then((e) => {
            setGlobalSpinner(false);
            formRef.current?.resetFields();
            HelperGeneral.alert("Mesajınız başarılı bir şekilde iletilmiştir.", "success");
        }).catch(e => {
            HelperGeneral.alert(e);
            setGlobalSpinner(false);
        })
    }

    const cardImgTemplate = (v) => {
        return (
            <div className={"position-relative"}>
                {
                    v?.isNew && (
                        <Tag
                            className={"bg-danger text-white rounded border-0 position-absolute"}
                            style={{right: 0, top: 10}}
                        >
                            <FontAwesomeIcon icon={faStar}/> YENİ
                        </Tag>
                    )
                }
                <img
                    alt={v?.name}
                    className={"mt-2 mb-2 w-100"}
                    src={require("../../../assets/images/png/theme/SHINIQ_Logo.png")}
                    onError={(e) => {
                        e.target.src = require("../../../assets/images/png/theme/SHINIQ_Logo.png")
                    }}
                />
            </div>
        )
    }

    const modalCancel = () => {
        setModalVisible(false);
        const el = playerRef.current;

        if (!el) return;

        if (typeof el.pause === "function") {
            el.pause();
            el.currentTime = 0;
            return;
        }

        if (el.video && typeof el.video.pause === "function") {
            el.video.pause();
            el.video.currentTime = 0;
        }
    };

    return (
        <div className={'my-account product-category archive pt-4 pb-4 min-height-container'}>
            <Container>
                <Row>
                    {
                        documents?.data?.filter((e) => e?.category_name === "Sensitive - Hassas Ciltler").map((data) => (
                            <Col xs={12}>
                                <span>{data?.url}</span>
                            </Col>
                        ))
                    }
                    <Col xs={12} md={3}>
                        <Row>
                            <Col xs={12} className={'position-relative'}>
                                <Spin spinning={loadingDocumentTypes}>
                                    <div className={'category-left-menu rounded pt-4 pb-4'}>
                                        <div className={`showFull`}>
                                            <h5 className={"text-center"}>SHINIQ Dünyası</h5>
                                            <ul>
                                                {
                                                    documentTypes?.map((v, i) => (
                                                            <li
                                                                key={i}
                                                                onClick={() => {
                                                                    setActiveDocumentType(v?.id)
                                                                }}
                                                                style={{
                                                                    '--overlay-color': '#FDE5D9',
                                                                    background: (activeDocumentType === v?.id ? '#FDE5D9' : ''),
                                                                }}>
                                                                <span className={`main-category `}>{v?.name}</span>
                                                            </li>
                                                        )
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </Spin>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={9} className={'info'}>
                        {
                            documentTypes?.filter((data) => data?.id === activeDocumentType)[0]?.subCats?.length > 0 && (
                                <Container>
                                    <Row>
                                        <div className={'documents-filter-div'}>
                                            {
                                                documentTypes?.filter((data) => data?.id === activeDocumentType)[0]?.subCats?.map((v) => (
                                                    <button
                                                        onClick={() => {
                                                            if (v?.id === activeSubCategory) {
                                                                getDocuments();
                                                                setActiveSubCategory(0);
                                                            } else {
                                                                getDocuments(v?.id);
                                                                setActiveSubCategory(v?.id);
                                                            }
                                                        }}
                                                        className={activeSubCategory === v?.id ? 'active' : ''}
                                                        style={activeSubCategory === v?.id ? {backgroundColor: overlayColors[v?.name], borderColor: overlayColors[v?.name]} : {}}
                                                        key={v?.id}
                                                    >
                                                        <span>{v?.name}</span>
                                                    </button>
                                                ))
                                            }
                                            {
                                                activeSubCategory !== 0 && (
                                                    <button
                                                        onClick={() => {
                                                            getDocuments();
                                                            setActiveSubCategory(0);
                                                        }}
                                                        className={'clear'}
                                                    >
                                                        <span>Temizle <FontAwesomeIcon icon={faXmark} size={8}/></span>
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </Row>
                                </Container>
                            )
                        }
                        <Spin spinning={loading}>
                            <Row>
                                {
                                    activeDocumentType === 32 ? (
                                        <div className={'product-history faq-div pharmacy'}>
                                            {faqData.find((data) => data?.id === 19)?.description ? ReactHtmlParser(faqData.find((data) => data?.id === 19)?.description) : ''}
                                        </div>
                                    ) : (
                                        activeDocumentType === 31 ? (
                                            <Container>
                                                <Row>
                                                    <Col xs={12} className={'m-0 d-flex basket'}>
                                                        <div className={'product-history'}>
                                                            <h4>İletişim Formu</h4>
                                                            <p>Düşüncelerinizi önemsiyoruz! İstek, öneri ve görüşlerinizi aşağıdaki form aracılığıyla kolayca bize iletebilirsiniz.</p>
                                                            <Form
                                                                layout={'vertical'}
                                                                ref={formRef}
                                                                initialValues={{
                                                                    firstName: UserInfo.info('first_name'),
                                                                    lastName: UserInfo.info('last_name'),
                                                                    email: UserInfo.info('email'),
                                                                }}
                                                                onFinish={(e) => {
                                                                    return onFinishMessageForm(e)
                                                                }}
                                                            >
                                                                <Row>
                                                                    <Col xs={12} md={6}>
                                                                        <Form.Item
                                                                            label={'Ad'}
                                                                            name={"firstName"}
                                                                            rules={[
                                                                                {
                                                                                    required: false,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input disabled={true}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={12} md={6}>
                                                                        <Form.Item
                                                                            label={'Soyad'}
                                                                            name={"lastName"}
                                                                            rules={[
                                                                                {
                                                                                    required: false,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input disabled={true}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        <Form.Item
                                                                            label={"E-posta Adresiniz"}
                                                                            name={"email"}
                                                                            rules={[
                                                                                {
                                                                                    required: false,
                                                                                    type: 'email',
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input disabled={true}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        <Form.Item
                                                                            label={"Mesajınız"}
                                                                            name={"message"}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <TextArea rows={4}/>
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col xs={8} md={3} className={'mx-auto'}>
                                                                        <Form.Item>
                                                                            <Button
                                                                                type={"primary"}
                                                                                className={'btn text-white btn-primary w-100'}
                                                                                style={{
                                                                                    border: 'none',
                                                                                    borderRadius: 3,
                                                                                    height: 46,
                                                                                }}
                                                                                htmlType={'submit'}
                                                                            >
                                                                                Gönder
                                                                            </Button>
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                            </Form>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        ) : (
                                            documents?.filter((data) => data?.category?.parentId === activeDocumentType).map((v, i) => (
                                                <Col xs={12} md={6} xl={4} className={'mb-4'}>
                                                    {
                                                        v?.info?.filesUrls?.length > 0 ? (
                                                            <Card
                                                                style={{cursor: 'pointer'}}
                                                                className={'archive-card'}
                                                                onClick={() => v?.info?.filesUrls?.length > 0 ? window.open(v?.info?.filesUrls[0]?.url, "_blank") : false}
                                                                cover={cardImgTemplate(v)}
                                                            >
                                                                <Meta title={v?.info?.name}/>
                                                            </Card>
                                                        ) : (
                                                            v?.info?.videosUrls?.length > 0 ? (
                                                                <Card
                                                                    style={{cursor: "pointer"}}
                                                                    className="archive-card"
                                                                    cover={cardImgTemplate(v)}
                                                                    onClick={() => {
                                                                        const url = v?.info?.videosUrls?.[0]?.url;
                                                                        if (!url) return;

                                                                        setModalMediaUrl(url);
                                                                        setModalVisible(true);
                                                                    }}
                                                                >
                                                                    <Meta title={v?.info?.name}/>
                                                                </Card>
                                                            ) : (
                                                                v?.info?.galleryImagesUrls && v?.info?.galleryImagesUrls.length > 0 ? (
                                                                    <Card
                                                                        style={{cursor: 'pointer'}}
                                                                        className="archive-card"
                                                                        cover={cardImgTemplate(v)}
                                                                        onClick={() => {
                                                                            const urls = v?.info?.galleryImagesUrls?.map((img) => img?.raw).filter(Boolean) ?? [];
                                                                            if (urls.length > 0) {
                                                                                setModalImageUrls(urls);
                                                                                setModalImageVisible(true);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Meta title={v?.info?.name}/>
                                                                    </Card>
                                                                ) : (
                                                                    <Card
                                                                        style={{cursor: 'pointer'}}
                                                                        className="archive-card"
                                                                        cover={cardImgTemplate(v)}
                                                                    >
                                                                        <Meta title={v?.info?.name}/>
                                                                    </Card>
                                                                )
                                                            )
                                                        )
                                                    }
                                                </Col>
                                            ))
                                        )
                                    )
                                }
                                {
                                    !loading && documents.length < 1 && (activeDocumentType !== 32 && activeDocumentType !== 31) && (
                                        <Empty description={'Arşiv kaydı bulunamadı'}/>
                                    )
                                }
                                <Modal
                                    visible={modalVisible}
                                    centered
                                    footer={null}
                                    onCancel={modalCancel}
                                    width={1000}
                                    destroyOnClose
                                >
                                    <video
                                        ref={playerRef}
                                        src={modalMediaUrl}
                                        controls
                                        autoPlay
                                        style={{width: "100%", height: "600px"}}
                                    />
                                </Modal>
                                <Modal
                                    visible={modalImageVisible}
                                    centered
                                    footer={null}
                                    onCancel={() => setModalImageVisible(false)}
                                    width="90%"
                                    style={{maxWidth: 900}}
                                    destroyOnClose
                                >
                                    {modalImageUrls?.length > 0 && (
                                        <div className="text-center">
                                            <img
                                                src={modalImageUrls[0]}
                                                alt=""
                                                style={{maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain'}}
                                            />
                                            <div className="mt-3">
                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        const url = modalImageUrls[0];
                                                        if (!url) return;
                                                        fetch(url, { mode: 'cors' })
                                                            .then((res) => res.blob())
                                                            .then((blob) => {
                                                                const blobUrl = window.URL.createObjectURL(blob);
                                                                const a = document.createElement('a');
                                                                a.href = blobUrl;
                                                                a.download = 'gorsel.' + (blob.type.split('/')[1] || 'png');
                                                                a.rel = 'noopener noreferrer';
                                                                a.click();
                                                                window.URL.revokeObjectURL(blobUrl);
                                                            })
                                                            .catch(() => window.open(url, '_blank'));
                                                    }}
                                                >
                                                    İndir
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </Modal>
                            </Row>
                        </Spin>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default withRouter(Archive);
